import {getPixelsFromRem, getSize, Integer} from 'platform/foundation';

/** The base height of a time slot in rem units */
export const ALL_DAY_EVENT_HEIGHT: Integer = 6;

/** The CSS-friendly size value for the slot height (includes 'rem' unit) */
export const CSS_ALL_DAY_EVENT_HEIGHT = getSize(ALL_DAY_EVENT_HEIGHT);

export const ALL_DAY_EVENT_HEIGHT_IN_PIXELS = Number(getPixelsFromRem(ALL_DAY_EVENT_HEIGHT));
